import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { Flex, Box, useToast } from '@chakra-ui/react';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import InputTextAreaExpandable from '../../forms/TextareaField/components/InputTextAreaExpandable';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';

import { sendContactLaunchdeckMessage, resetSendContactLaunchdeckMessage } from '../../marketing/actions/marketing-actions'
import { redirectToNewPage, triggerLaunchdeckToast, validateEmail } from '../../global/helpers/global-helpers';


function ContactLaunchdeckForm({
	contactLaunchdeckOutcome,
	contactLaunchdeckInProgress,
	isMobileView,
	sendContactLaunchdeckMessage,
	resetSendContactLaunchdeckMessage
}) {

	const toast = useToast();

	const [showSubmitted, setShowSubmitted] = useState(false)
	const [isEmptyName, setEmptyName] = useState(false)
	const [isInvalidEmail, setIsInvalidEmail] = useState(false)
	const [localState, setLocalState] = useState({
		userName: "",
		email: "",
		message: "",
	})

	const { email, userName, message } = localState || {};

	useEffect(() => {
		if (contactLaunchdeckOutcome) {
			const { messageSentSuccessfully } = contactLaunchdeckOutcome || {}

			if (!!messageSentSuccessfully) {
				setShowSubmitted(true)
			} else {
				toast(
					triggerLaunchdeckToast({
						useCase: "show-error-state",
						label: "Unfortunately something went wrong. Please try again later.",
						isMobileView
					})
				)
			}

			resetSendContactLaunchdeckMessage()
		}
	}, [contactLaunchdeckOutcome, isMobileView, toast, resetSendContactLaunchdeckMessage]);



	const handleChange = (event) => {
		const value = event.target.value;

		if (event.target.name === "email") {
			setIsInvalidEmail(false)
		} else if (event.target.name === "userName") {
			setEmptyName(false)
		}

		setLocalState(prevState => ({
			...prevState,
			[event.target.name]: value
		}));
	}

	const handleSubmitForm = () => {
		const isValidEmail = validateEmail(email);
		let passValidation = true;

		if (!isValidEmail) {
			setIsInvalidEmail(true)
			passValidation = false
		}  

		if (!userName || userName?.trim().length < 1) {
			setEmptyName(true)
			passValidation = false
		}
		
		if (passValidation) {
			sendContactLaunchdeckMessage({
				userName: userName,
				email: email,
				message: message
			})
		}
	}


	if (showSubmitted) {
		return (
			<Flex direction='column' align='center' w='100%' maxW={'30em'} >
				<Box border='1px' borderColor='brand.500' rounded='0.5em' w='100%' bg='white' p='1em'  my='2em' >
					<Box textAlign='center' className='flip-in-hor-bottom'>   <span role="img" aria-label="ok-hand"> 👌</span> We have received your message</Box>
					<Box mt='1em' textAlign='center' fontSize='0.8em'>Meanwhile, try Launchdeck out for free? </Box>
				</Box>
					<LaunchdeckButton bg='brand.500' color='white' onClick={() => redirectToNewPage('/home')} label='OK' />
			</Flex>
		)
	} else {
		return (
			<Flex justify='center' w='100%' maxW={'35em'}>
					<Flex my='0.5em' w='80%' justify='center'>
						<Flex direction='column' mt='2em'  w='100%' maxW='35em' gap='1.5em'>

						<LaunchdeckFormInput
							label='Your name'
							name={'userName'}
							onChange={handleChange}
							value={userName}
							placeholder={'Please let us know who we are getting back to'}
							isRequired={true}
							isDisabled={contactLaunchdeckInProgress}

							errorLogic={isEmptyName}
							errorMessage={'Required'}
						/>

						<LaunchdeckFormInput
							label='How to get back to you'
							name={'email'}
							onChange={handleChange}
							value={email}
							placeholder={'Email'}
							isRequired={true}
							isDisabled={contactLaunchdeckInProgress}

							errorLogic={isInvalidEmail}
							errorMessage={'Please use a valid email'}
						/>
					

						<Box>
							<Box mb='0.8em' lineHeight='1.275em' fontWeight='600' fontSize='0.8em' color={'gray.700'}>
								Tell us what you're thinking
							</Box>
							
							<InputTextAreaExpandable
								name={'message'}
								onChangeHandler={handleChange}
								inputValue={message}
								placeholder={`Your thoughts here...`}
								border={'1px solid #E5EAEF'}
							/>
						</Box>
						
						<Box mt='1.5em'>
							<LaunchdeckButton bg='brand.500' color='white' px='5em' w='100%' maxW={['100%','35em']} 
							loadingLogic={contactLaunchdeckInProgress}
							onClick={() => handleSubmitForm()} label='Send message' />
							</Box>
						</Flex>
					</Flex>
			</Flex>
		);
	}
};


function mapStateToProps(state) {
	return {
		contactLaunchdeckOutcome: state.contactLaunchdeckOutcome.results.data,
		contactLaunchdeckInProgress: state.contactLaunchdeckOutcome.isLoading,
		isMobileView: state.mobileViewMode.isMobileView
	};
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			sendContactLaunchdeckMessage,
			resetSendContactLaunchdeckMessage
		},
		dispatch,
	)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContactLaunchdeckForm));